import { claimPendingOAuthLoginSideEffects } from '@/lib/auth/oauth-redirect-state';
import { persistOAuthTokensFromUrl } from '@/lib/auth/oauth-redirect';
import { runPostLoginCartSync } from '@/lib/cart-sync/run-post-login-cart-sync';
import { authorizationAtom } from '@/store/authorization-atom';
import { getDefaultStore } from 'jotai';

const NETCORE_LOGIN_TRIGGER_KEY = 'netcore_login_trigger_reason';

/**
 * Persist OAuth URL tokens (if any) and run post-login side effects at most once.
 * Returns whether this caller claimed and ran those side effects.
 */
export async function finishOAuthLoginFromUrl(): Promise<boolean> {
  persistOAuthTokensFromUrl();

  if (!claimPendingOAuthLoginSideEffects()) {
    return false;
  }

  await runPostLoginCartSync();
  getDefaultStore().set(authorizationAtom, true);

  try {
    sessionStorage.setItem(NETCORE_LOGIN_TRIGGER_KEY, 'social');
  } catch {
    // sessionStorage can throw in private browsing
  }

  return true;
}
